import { Component } from "@angular/core";

@Component({
    selector: "app-health-page",
    templateUrl: "./health-page.component.html",
    styleUrls: ["./health-page.component.scss"],
    standalone: false
})
export class HealthPageComponent {
  constructor() {}
}
